<template>
  <div id="hero" class="hero-wrap style5 hero-bg-11 bg-f">
    <div class="overlay op-9 bg-prussian"></div>
    <div class="container">
      <div class="row gx-5 align-items-center">
        <div class="col-lg-6">
          <div class="hero-content" data-speed="0.10" data-revert="true">
            <h1 style="display: block;
              margin-bottom: 8px;
              color: var(--clr_redical);
              font-size: 25px;
          }">Ópticas Empresariales</h1>
            <h2 style="font-size: 75px;
                color: var(--clr_white);
                line-height: 1;">Soluciones Visuales para Empresas &amp; su Personal</h2>
            <p style="font-size: 20px;line-height: 1.1;">
              Ofrecemos servicios ópticos empresariales, diseñados para empresas que buscan mejorar el bienestar de sus colaboradores y sus familias a través de convenios exclusivos con aseguradoras.
            </p>
            <div class="hero-btn">
              <a href="#contacto" class="btn style2">Solicitar Visita</a>
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="hero-img-wrap d-flex">
            <div class="hero-img-one bounce">
              <img src="../../assets/images/hero/hero-img-2.png" alt="Image" />
            </div>
            <div class="hero-img-two bounce">
              <img src="../../assets/images/hero/hero-img-1.png" alt="Image" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainBanner",
};
</script>